// extracted by mini-css-extract-plugin
export var checkbox = "_5t-0";
export var circle = "_5t-3";
export var horizontalContainer = "_5t-7";
export var sm = "_5t-5";
export var switch0 = "_5t-2";
export var switchDisabled = "_5t-8";
export var switchEnabled = "_5t-1";
export var textSwitchContainer = "_5t-9";
export var textSwitchOption = "_5t-a";
export var textSwitchOptionSelected = "_5t-b";
export var verticalContainer = "_5t-6";
export var xs = "_5t-4";